export enum PlanPacketStatus {
	Incomplete = 'Incomplete',
	Submitted = 'Submitted',
	Sending = 'Sending',
	ManuallyResolved = 'ManuallyResolved',
}
